"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LeftAlignEnabled = function LeftAlignEnabled(props) {
  return _react2.default.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), _react2.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react2.default.createElement("path", {
    stroke: "#0065DB",
    d: "M1.5 1.5h15v15h-15z"
  }), _react2.default.createElement("path", {
    strokeOpacity: 0.296,
    stroke: "#0065DB",
    strokeWidth: 4,
    d: "M-1-1h20v20H-1z"
  }), _react2.default.createElement("path", {
    stroke: "#FFF",
    d: "M.5.5h17v17H.5z"
  }), _react2.default.createElement("path", {
    fill: "#0065DB",
    d: "M1 1h2v16H1zM4 6h11v2H4zM4 10h6v2H4z"
  })));
};

exports.default = LeftAlignEnabled;